import ENV from "../../env";
import getAuthHeaders from "../authHeaders";

const createUser = async (details) => {
  const headers = await getAuthHeaders();
  
  const response = await fetch(`${ENV.firebaseApiUrl}/user/create`, {
    method: "POST",
    headers,
    body: JSON.stringify({
      user: details,
    }),
  });

  const resData = await response.json();

  if (!response.ok) {
    throw new Error("Create user failed: " + resData.message);
  }

  return resData.userId;
};

export default createUser;
